import { render, staticRenderFns } from "./daikoushenpi.vue?vue&type=template&id=504fd4db&scoped=true"
import script from "./daikoushenpi.vue?vue&type=script&lang=js"
export * from "./daikoushenpi.vue?vue&type=script&lang=js"
import style0 from "./daikoushenpi.vue?vue&type=style&index=0&id=504fd4db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504fd4db",
  null
  
)

export default component.exports